import tw from "twin.macro";
import styled from "styled-components";

export const One = styled.h1(tw`text-4xl block font-bold font-montserrat`);
export const Two = styled.h2(tw`text-2xl block font-bold font-montserrat`);
export const Three = styled.h3(tw`text-xl block font-bold font-montserrat`);
